export default __webpack_public_path__ + "static/media/banner.b819e052.jpg";